export default {
  title: 'Contadores',
  callBackSuccess: function () {},
  fields: [
    {
      type: 'input',
      inputType: 'text',
      label: 'ID',
      model: 'id',
      inputName: 'id',
      readonly: true,
      disabled: true,
      visible: false,
      required: false
    },
    {
      type: 'group',
      data: [
        {
          type: 'input',
          inputType: 'text',
          label: 'Nome',
          model: 'nome',
          group: true,
          inputName: 'nome',
          readonly: false,
          disabled: true,
          visible: true,
          required: true
        },
        {
          type: 'input',
          inputType: 'text',
          label: 'cnpj',
          model: 'cnpj',
          group: true,
          inputName: 'cnpj',
          readonly: false,
          disabled: true,
          visible: true,
          required: true
        }
      ]
    },
    {
      type: 'input',
      inputType: 'text',
      label: 'Contato',
      model: 'contato',
      group: true,
      inputName: 'contato',
      readonly: false,
      disabled: true,
      visible: true,
      required: false
    },
    {
      type: 'input',
      inputType: 'text',
      label: 'Responsável',
      model: 'responsavel',
      group: true,
      inputName: 'responsavel',
      readonly: false,
      disabled: true,
      visible: true,
      required: false
    },
    {
      type: 'select',
      label: 'Representante',
      model: 'representante',
      inputName: 'representante',
      visible: true,
      itens: [],
      readonly: false,
      disabled: true
    }
  ]
}
